import { colors } from '../../config'

export default{
    computed:{
    },
    methods:{
        statustoString(asset){          
            let arr = ["EVENT","NONE","USER_DEFINED",""]
            
            if(asset.statusType == "EVENT")
                return asset.statusCode == "OK" || asset.statusCode == "NEW" ? "Status OK" : "Event geeft storing aan"
            else if(asset.statusType == "NONE")
                return asset.statusCode == "OK" || asset.statusCode == "NEW" ? "Status OK" : "Een onbekend probeel geeft storig"
            else if(asset.statusType == "USER_DEFINED")
                return asset.statusCode == "OK" || asset.statusCode == "NEW" ? "Status OK" : "Storing op gebruiker ingesteld event"
            else
                return asset.statusType                                  
        },     

        statusToIconString(asset){
            let arr = ["OK","NEW","ERROR"]

            // status code not found in array means its an icon so show directly
            if(arr.indexOf(asset.statusCode) == -1){
                return asset.statusCode
            }

            // otherwise show icon
            return asset.statusCode == "OK" || asset.statusCode == "NEW" ? "fal fa-check" : "fal fa-exclamation-triangle"
        }   
    }
} 